import { lazy } from 'react';
export var CoursePageAsync = lazy(function () { return import('./CoursePage'); });
